module.exports = __webpack_public_path__ + "static/media/fakes-smurnaikes-kapnisth-regga.8111f5a1.jpg";